/**
 * @lodex-pro/web-portal/public/SignupClosedPage — operator self-signup is closed.
 *
 * Operator portal rework PR 1 (lx-coord/operator-portal-design.md §2.4): Paelode Systems now
 * creates operator companies and their users, and emails each user a temporary password. The
 * old /portal/register and /portal/verify links (bookmarks, old verification emails) land here
 * instead of a dead form. The API's register and magic-link routes answer 410 for the same
 * reason. Disposal sign-up (/portal/disposal/*) is unchanged.
 */

import React from 'react';
import { Link } from 'react-router-dom';

export function SignupClosedPage(): React.JSX.Element {
  return (
    <section aria-labelledby="signup-closed-heading" data-testid="signup-closed-page">
      <h1 id="signup-closed-heading" style={{ fontSize: '22px', margin: '0 0 12px' }}>
        Portal accounts are set up by Paelode Systems
      </h1>
      <p style={{ lineHeight: 1.5, margin: '0 0 12px', color: 'var(--color-text-secondary)' }}>
        Operator companies no longer sign up here. Paelode Systems creates your company&rsquo;s
        portal and emails each person a temporary password.
      </p>
      <p style={{ lineHeight: 1.5, margin: '0 0 20px', color: 'var(--color-text-secondary)' }}>
        If you need access, ask your company&rsquo;s portal admin, or contact your Paelode Systems
        administrator.
      </p>
      <Link to="/portal" style={{ color: 'var(--color-link)' }}>
        Already have an account? Sign in
      </Link>
    </section>
  );
}
